import type { SignInOTPRequest } from '@/types';

import React from 'react';

import { CodeLoginCodeForm, CodeLoginMobileForm } from './_components';

import { Stack } from '@/components';

const CodeLoginForm: React.FC = () => {
  const [step, setStep] = React.useState<'mobile' | 'code'>('mobile');
  const [signInData, setSignInData] = React.useState<SignInOTPRequest>({
    mobile: '',
    country_code_prefix: '+98',
  });

  const inView = {
    mobile: (
      <CodeLoginMobileForm
        goNext={(data) => {
          setSignInData(data);
          setStep('code');
        }}
      />
    ),
    code: (
      <CodeLoginCodeForm
        mobile={signInData.mobile}
        country_code_prefix={signInData.country_code_prefix}
      />
    ),
  };

  return (
    <Stack
      w="100%"
      h="100%"
      align="flex-start"
      gap={4}
      pt={4}
      display="flex"
      flexDir="column"
      flex={1}
    >
      {inView[step]}
    </Stack>
  );
};
export default CodeLoginForm;
